import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    jwtToken: null,
    domain: null,
    region: null,
    country: null,
    gender: null,
  },
  getters: {
    jwtToken: state => state.jwtToken,
    domain: state => state.domain,
    domainWithoutDot: state => state.domain.replace('.', ''),
    region: state => state.region,
    country: state => state.country,
    gender: state => state.gender,
  },
  mutations: {
    setJwtToken: (state, jwtToken) => {
      const $state = state;
      $state.jwtToken = jwtToken;

      localStorage.setItem('jwtToken', jwtToken);
    },
    removeJwtToken: (state) => {
      const $state = state;
      $state.jwtToken = null;

      localStorage.removeItem('jwtToken');
    },
    setDomain: (state, domain) => {
      const $state = state;
      $state.domain = domain;
    },
    setRegion: (state, region) => {
      const $state = state;
      $state.region = region;

      localStorage.setItem('region', region);
    },
    setCountry: (state, country) => {
      const $state = state;
      $state.country = country;

      localStorage.setItem('country', country);
    },
    setGender: (state, gender) => {
      const $state = state;
      $state.gender = gender;

      localStorage.setItem('gender', gender);
    },
  },
});

export default store;
